import { ProductDetailsElement } from "@redotech/redo-content-builder-common/forge/review-forge-types";
import { memo, useContext } from "react";
import { Flex } from "../../flex";
import { InspectorConfig } from "../../inspector";
import { Text } from "../../text";
import {
  BrandKitContext,
  ProductBeingReviewedContext,
} from "../review-form-editor-contexts";

export const ReviewsProductDetails = memo(function ReviewsProductDetails({
  element,
}: {
  element: ProductDetailsElement;
}) {
  const brandKit = useContext(BrandKitContext);
  const product = useContext(ProductBeingReviewedContext);

  const fontFamily = brandKit.font.bodyFontFamily; // NOTE: Assuming body font is used for product details

  const showVariantTitle = element.showVariantTitle ?? false;
  const preferVariantImage = element.preferVariantImage ?? false;
  const displayImageUrl =
    preferVariantImage && product.variantImageUrl
      ? product.variantImageUrl
      : product.imageUrl;

  return (
    <Flex align="center" dir="column" style={{ fontFamily }}>
      <img
        alt="Product image"
        src={displayImageUrl}
        style={{ width: element.imageWidthPercentage + "%" }}
      />
      <Text fontSize="md" fontWeight="medium">
        {product.title}
      </Text>
      {showVariantTitle && product.variantTitle && (
        <Text fontSize="sm" fontWeight="thin" textColor="secondary">
          {product.variantTitle}
        </Text>
      )}
      {product.purchaseDate && (
        <Text fontSize="sm" fontWeight="thin" textColor="secondary">
          {`Purchased on ${product.purchaseDate.getMonth() + 1}/${product.purchaseDate.getDate()}/${product.purchaseDate.getFullYear()}`}
        </Text>
      )}
    </Flex>
  );
});

export const productDetailsInspector: InspectorConfig<ProductDetailsElement> = {
  sections: [
    {
      label: "Product details",
      fields: [
        {
          widget: "number",
          label: "Image Width Percentage",
          path: "imageWidthPercentage",
          min: 0,
          max: 100,
        },
        {
          widget: "toggle",
          label: "Use variant image",
          path: "preferVariantImage",
        },
        {
          widget: "toggle",
          label: "Show variant title",
          path: "showVariantTitle",
        },
      ],
    },
  ],
};
